<template>
  <section class="profile">
    <section class="profile-number">
      <a href="javascript:" class="profile-link">
        <div class="profile_image">
          <img class="icon-person" :src="headimgurl"/>
          <!--<img class="icon-person" src="./images/tu.jpg"/>-->
        </div>
        <div class="user-info">
          <p class="user-info-top">{{userInfo.nickName ? userInfo.nickName : userInfo.account}}</p>
        </div>
      </a>
    </section>
    <section class="profile_my_order border-1px">
      <!-- 地址管理 -->
      <a href='javascript:' class="my_order" @click="gotoPath('/addressmanage')">
        <span>
          <img class="iconImg iconOrderList" src="./images/wd_icon1.png"/>
        </span>
        <div class="my_order_div">
          <span>地址管理</span>
          <span class="my_order_icon">
            <i class="iconfont iconNext"></i>
          </span>
        </div>
      </a>
	  <!--&lt;!&ndash; 优惠券 &ndash;&gt;-->
	  <!--<a href='javascript:' class="my_order" @click="gotoPath('/coupon')">-->
	    <!--<span>-->
	      <!--<img class="iconImg iconOrderList" src="./images/yhq.png"/>-->
	    <!--</span>-->
	    <!--<div class="my_order_div">-->
	      <!--<span>优惠券</span>-->
	      <!--<span class="my_order_icon">-->
	        <!--<i class="iconfont iconNext"></i>-->
	      <!--</span>-->
	    <!--</div>-->
	  <!--</a>-->
      <!-- 缴费订单 -->
      <a href='javascript:' class="my_order" @click="gotoPath('/order')">
        <span>
          <img class="iconImg iconOrderList" src="./images/wd_btn_1.png"/>
        </span>
        <div class="my_order_div">
          <span>缴费订单</span>
          <span class="my_order_icon">
            <i class="iconfont iconNext"></i>
          </span>
        </div>
      </a>
      <!-- 供热报修 -->
      <a href='javascript:' class="my_order" @click="gotoPath('/repairorder')">
        <span>
          <img class="iconImg iconOrderList" src="./images/wd_btn_2.png"/>
        </span>
        <div class="my_order_div">
          <span>供热报修订单</span>
          <span class="my_order_icon">
            <i class="iconfont iconNext"></i>
          </span>
        </div>
      </a>
	  <!--&lt;!&ndash; 供热报停 &ndash;&gt;-->
	  <a href='javascript:' class="my_order" @click="gotoPath('/stop')">
	    <span>
	      <img class="iconImg iconOrderList" src="./images/wd_btn_3.png"/>
	    </span>
	    <div class="my_order_div">
	      <span>在线报停订单</span>
	      <span class="my_order_icon">
	        <i class="iconfont iconNext"></i>
	      </span>
	    </div>
	  </a>
	  <!-- 在线评价 -->
	  <a href='javascript:' class="my_order" @click="gotoPath('/evaluateList')">
	    <span>
	      <img class="iconImg iconOrderList" src="./images/wd_btn_4.png"/>
	    </span>
	    <div class="my_order_div">
	      <span>在线评价</span>
	      <span class="my_order_icon">
	        <i class="iconfont iconNext"></i>
	      </span>
	    </div>
	  </a>
	  <a href='javascript:' class="my_order" @click="gotoPath('/updatephone')">
	    <span>
	      <img class="iconImg iconOrderList" src="./images/wd_btn_4.png"/>
	    </span>
	    <div class="my_order_div">
	      <span>修改手机号</span>
	      <span class="my_order_icon">
	        <i class="iconfont iconNext"></i>
	      </span>
	    </div>
	  </a>
    </section>
  </section>
</template>

<script>
	import {bqCompanyId} from '../../common/js/env'
	export default {
    name:"profile",
    data (){
      return{
        userInfo:'',
        headimgurl:'',
		isShowApply:false,//是否显示发票列表
      }
    },
    created () {
      this.headimgurl = this.$cookies.get('wxUserInfo').headimgurl
      this.userInfo = this.$cookies.get('userInfo');
	  console.log(this.userInfo)
	  if(this.$cookies.get('companyId') == bqCompanyId){
	  		  this.isShowApply = true
	  }
    },
	  methods:{
		gotoPath(path){
			this.$router.push({
			  path:path,
			  name:path.substring(1)
			})
		}
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .profile
    padding-top 0
    width 100%
    .profile-number
      .profile-link
        clearFix()
        position relative
        display block
        background url('./images/xbanner.png') no-repeat center
        background-size 100% 100%
        padding 60px 10px
        .profile_image
          width 160px
          height 160px
          background #ffa42c
          border-radius 50%
          overflow hidden
          vertical-align top
          padding 10px 10px;
          position relative
          left 50%
          margin-left -90px
          .icon-person
            border 1px solid #ffc880 /*no*/
            width 100%
            height 100%
            border-radius 50%
            background #ffa42c
        .user-info
          justify-content center
          text-align center
          margin-top 8px
          margin-left 15px
          p
            font-weight: 700
            font-size 28px
            color #fff
            &.user-info-top
              padding 8px 0px
            .user-icon
              display inline-block
              margin-left -15px
              margin-right 5px
              width 20px
              height 20px
              .icon-mobile
                font-size 30px
                vertical-align text-top
            .icon-mobile-number
              font-size 14px
              color #fff
        .arrow
          width 12px
          height 12px
          position absolute
          right 15px
          top 40%
          .icon-jiantou1
            color #fff
            font-size 5px
    .profile_my_order
      top-border-1px(#e4e4e4)
      margin-top 10px
      .my_order
        height 100px
        display flex
        align-items center
        padding-left 15px
        background #fff
        margin 10px 0px
        >span
          display flex
          align-items center
          width 20px
          height 20px
          >.iconImg
            margin 20px 20px
            width 40px
            height auto
        .my_order_div
          width 100%
          padding 32px 10px 32px 60px
          font-size 24px
          color #333
          display flex
          justify-content space-between
          span
            display block
          .my_order_icon
            margin-right 50px
            .iconNext
              display inline-flex;
              display -webkit-inline-flex;
              width 13px
              height 23px
              background url("./images/xjt_btn.png") no-repeat center
              background-size 100% 100%
              color #bbb
              font-size 10px
</style>



// WEBPACK FOOTER //
// src/pages/Profile/Profile.vue